<script>
// import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
// import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { generateUUID } from "@/utils";
import WeekTime from "@/view/components/campaigns/WeekTime.vue";
// import Treeselect2Vue from "../../pages/plugins/treeselect/Treeselect2.vue";

export default {
  name: "week-day",
  props: ["item", "schedules"],
  components: {
    WeekTime
  },
  data() {
    return {
      startTime: "",
      endTime: "",
      items: [],
      savedItem: null,
      schedData: []
    };
  },
  mounted() {
    // console.log("this.schedules", this.schedules);
    // console.log("this.item", this.item);
    let filter_results = this.schedules.filter(obj => obj.day == this.item);
    // console.log("filter_results", filter_results);
    // Initial progress
    this.schedData = filter_results && filter_results.length > 0 ? filter_results : [];
    this.addSchedule();
    
  },
  watch: {
    startTime() {
      this.handleChange();
    },
    endTime() {
      this.handleChange();
    }
  },
  methods: {
    getObjSched() {
      return {
        uuid: "",
        week_day: "",
        start_time: "",
        end_time: "",
        start_time_id: "",
        end_time_id: ""
      };
    },
    generateNewTime() {
      if (this.schedData.length > 0) {
        var obj = this.getObjSched();
        for (var i = 0; i < this.schedData.length; i++) {
          var val = this.schedData[i];
          // console.log(val.value);
          var uuid = "";
          if (i % 2 == 0) {
            uuid = generateUUID();
            obj.uuid = uuid;
            obj.week_day = val.day;
            obj.start_time = val.value;
            obj.start_time_id = `start_time_id_${uuid}`;
            obj.end_time_id = `end_time_id_${uuid}`;
          } else {
            obj.end_time = val.value;
            this.items.push(obj);
            obj = this.getObjSched();
          }
        }
      } else {
        let uuid = generateUUID();
        this.items.push({
          uuid: uuid,
          week_day: this.item,
          start_time: "",
          end_time: "",
          start_time_id: `start_time_id_${uuid}`,
          end_time_id: `end_time_id_${uuid}`
        });
      }
    },
    addSchedule() {
      this.generateNewTime();
    },
    handleChange() {
      // console.log("weekday");
      this.$emit("input");
    }
  }
};
</script>

<template>
  <div>
    <div style="text-transform:capitalize">
      <strong>{{ item }}</strong>
    </div>
    <template v-for="item in items">
      <div class="d-flex align-items-center mt-2" :key="item.uuid">
        <div>
          <week-time
            :item="item"
            timepos="start"
            label="Start Time"
            @input="handleChange"
          >
          </week-time>
        </div>
        <div class="ml-5">
          <week-time
            :item="item"
            timepos="end"
            label="End Time"
            @input="handleChange"
          >
          </week-time>
        </div>
      </div>
    </template>
    <div class="mt-2 mb-5">
      <a href="#" @click.prevent="addSchedule()">
        + Add another time on
        <span style="text-transform: capitalize">
          {{ item }}
        </span>
      </a>
    </div>
  </div>
</template>
